import React, { Component } from 'react';
import lodashValues from 'lodash/fp/values';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import { SCREEN_ID_SUNSETUP_INVENTORY } from 'client/constants/screenIds';
import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';

import DriverActions from 'client/actions/Driver';
import MarketActions from 'client/actions/Market';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrSunSetupAdminUpdateItem from 'client/components/SrSunSetupAdminUpdateItem/SrSunSetupAdminUpdateItem';
import SrInventoryPerMarketDataTable from 'client/components/SrInventoryPerMarketDataTable/SrInventoryPerMarketDataTable';
import SrInventoryItemsDataTable from 'client/components/SrInventoryItemsDataTable/SrInventoryItemsDataTable';
import SrDriversDataTable from 'client/components/SrDriversDataTable/SrDriversDataTable';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_SUNSETUP_INVENTORY)
@branch({
  driversByMarketId: ['drivers', 'byMarketId'],
  marketsById: ['markets', 'byId'],
})
@withScrollToTop
class AdminInventoryPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Inventory',
    section: 'Admin',
  });

  static fetchData(match, inject) {
    return Promise.all([DriverActions.getDriverList(inject), MarketActions.getList(inject)]);
  }

  render() {
    const { driversByMarketId, marketsById } = this.props;

    const markets = lodashValues(marketsById).sort((a, b) =>
      a.displayName.localeCompare(b.displayName),
    );
    const drivers = lodashValues(driversByMarketId)
      .reduce((acc, drivers) => {
        return acc.concat(drivers);
      }, [])
      .sort((a, b) => a.name.localeCompare(b.name));

    return (
      <SrPartnerPageV2 navbarTitle="SunSetup">
        <SrBox>
          <SrBox marginBottom="16px">
            <SrText font="greycliff" fontSize="20px" weight="800">
              Inventory Items Per Market
            </SrText>
          </SrBox>
          <SrInventoryPerMarketDataTable maxHeight="400px" />
        </SrBox>
        <SrBox marginTop="24px">
          <SrBox marginBottom="16px">
            <SrText font="greycliff" fontSize="20px" weight="800">
              Inventory Items
            </SrText>
          </SrBox>
          <SrInventoryItemsDataTable
            maxHeight="400px"
            markets={markets || []}
            drivers={drivers || []}
          />
        </SrBox>
        <SrBox marginTop="24px">
          <SrBox marginBottom="16px">
            <SrText font="greycliff" fontSize="20px" weight="800">
              Drivers
            </SrText>
          </SrBox>
          <SrDriversDataTable maxHeight="400px" />
        </SrBox>
        <SrSunSetupAdminUpdateItem />
      </SrPartnerPageV2>
    );
  }
}

AdminInventoryPage.displayName = 'AdminInventoryPage';

export default AdminInventoryPage;
